import { Overline, Reveal } from "./Shared";
import { PROCESS } from "../../lib/site";

export const Process = () => (
  <section id="process" className="relative py-24 md:py-32 bg-ink" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="text-center max-w-2xl mx-auto">
        <Overline className="justify-center">How It Works</Overline>
        <h2 className="mt-5 font-heading font-light text-4xl md:text-6xl text-white leading-[1.02]">
          Booked in <span className="italic text-gold">three</span> simple steps
        </h2>
      </div>

      <div className="mt-20 grid md:grid-cols-3 gap-10 md:gap-8 relative">
        <div className="hidden md:block absolute top-[2.75rem] left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
        {PROCESS.map((p, i) => (
          <Reveal key={p.no} delay={i * 0.12} className="relative text-center">
            <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full border border-gold/40 bg-ink relative z-10">
              <span className="font-heading text-2xl text-gold">{p.no}</span>
            </div>
            <h3 className="font-heading text-2xl text-white">{p.title}</h3>
            <p className="mt-4 text-white/55 text-sm leading-relaxed max-w-xs mx-auto">{p.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
